// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"1ca82153","352":"6a0d113a","775":"6903635b","778":"f426dbf7"}[chunkId] + ".chunk.css";
};